import { currencyIcons } from '../../constants/assets'
import { cn } from '../../utils/cn'

type MoneyLabelProps = {
  amount: string
  tone?: 'light' | 'dark'
  className?: string
}

/** The euro glyph is an exported vector, mirrored vertically in the design. */
export const MoneyLabel = ({ amount, tone = 'dark', className }: MoneyLabelProps) => (
  <span className={cn('flex h-[11px] items-center gap-px', className)}>
    <span className="block shrink-0 -scale-y-100">
      <img
        alt="EUR"
        className="block h-[9.723px] w-[6.75px] max-w-none"
        src={tone === 'light' ? currencyIcons.euroWhite : currencyIcons.euroBlack}
      />
    </span>
    <span
      className={cn(
        'font-host text-[13px] font-bold leading-[10px]',
        tone === 'light' ? 'text-white' : 'text-black',
      )}
    >
      {amount}
    </span>
  </span>
)
